/* eslint-disable react/no-unstable-nested-components */
import classNames from "components/ui/classNames";
import { RefreshCwIcon } from "lucide-react";
import type { HTMLAttributes } from "react";
interface RefreshButtonProps extends HTMLAttributes<HTMLButtonElement> {
  loading: boolean;
}
export default function RefreshButton({ loading, className, ...props }: RefreshButtonProps) {
  return (
    <button
      {...props}
      disabled={loading}
      type="button"
      className={classNames(
        "rounded-xl border border-slate-200 bg-slate-50/60 p-2 text-slate-600",
        "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
        {
          "bg-violet-50 text-violet-600": loading,
        },
        "focus-visible:outline-none",
        "focus-visible:ring-1 focus-visible:ring-offset-1",
        "focus-visible:ring-gray-100 focus-visible:ring-offset-gray-300",
        "focus-visible:border-transparent focus-visible:bg-gray-50 focus-visible:text-gray-600",
        "dark:focus-visible:ring-slate-950 dark:focus-visible:ring-offset-transparent",
        className,
      )}
    >
      <RefreshCwIcon
        strokeWidth={2}
        className={classNames({
          "animate-spin": loading,
        })}
      />
    </button>
  );
}
